
const state = {
  acceptance_required: false,
  disclaimer_text: '',
  entity_id: undefined,
  entity_type: '',
  id: null,
  provider_id: undefined,
}

export const requiredFields = [
  { key: 'disclaimer_text' },
  { key: 'entity_id' },
  { key: 'entity_type' },
  { key: 'provider_id' },
]

export default state
